export const REGEX = {
  IS_NON_WHITE_SPACE: /^\S*$/,
  ALPHANUMERIC: /^[a-zA-Z0-9-_]{3,64}$/,
  ALPHANUMERIC_32_CHAR: /^[a-zA-Z0-9-_]{3,32}$/,
  EMAILREGEX: /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/,
  IS_CONTAINS_UPPERCASE: /^(?=.*[A-Z]).*$/,
  IS_CONTAINS_LOWERCASE: /^(?=.*[a-z]).*$/,
  IS_CONTAINS_NUMBER: /^(?=.*[0-9]).*$/,
  IS_CONTAINS_SYMBOL: /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/,
  IS_VALID_LENGTH: /^.{6,16}$/,
};

export const PROVIDER_CONSTANT_PROPS = {
  CREATE_PROVIDER: 'Create Provider',
  EDIT_PROVIDER: 'Edit Provider',
  GENERIC: {
    CONFIRM: 'confirm',
    DELETE: 'delete',
    TOAST_TIME: 3000,
    DELAY: 1000,
  },
  SELECTED_PROVIDER_ID: 'selectedProviderId',

  // Page-level strings
  PAGE: {
    EDIT_SUBTITLE: 'Update provider configuration and settings',
    CREATE_SUBTITLE: 'Configure and create a new provider',
    REQUIRED_FIELDS_HINT: 'All required fields must be filled',
    RESET: 'Reset',
    CANCEL: 'Cancel',
    UPDATE_PROVIDER: 'Update Provider',
  },

  // Section card titles & subtitles
  SECTIONS: {
    PROVIDER_INFO_TITLE: 'Provider Information',
    PROVIDER_INFO_SUBTITLE: 'Enter provider details and server configuration',
    CONFIG_TITLE: 'Configuration Settings',
    CONFIG_SUBTITLE: 'Manage VDI and service configurations',
  },

  // Form field labels and placeholders
  FIELDS: {
    VMS_SERVER_LABEL: 'VMS Server',
    VMS_SERVER_PLACEHOLDER: 'Select VMS Server',
    PROFILE_NAME_LABEL: 'Profile Name',
    PROFILE_NAME_PLACEHOLDER: 'Enter profile name',
    PROVIDER_NAME_LABEL: 'Provider Name',
    PROVIDER_NAME_PLACEHOLDER: 'Enter provider name',
    PARTNER_ID_LABEL: 'Partner ID',
    PARTNER_ID_PLACEHOLDER: 'Auto-generated if empty',
    VDI_VERSION_LABEL: 'VDI Version',
    VDI_SYNC_LABEL: 'VDI Sync',
    VDI_SYNC_ENABLED: 'Enabled',
    VDI_SYNC_DISABLED: 'Disabled',
    V1_LABEL: 'V1',
    V2_LABEL: 'V2',
  },

  // Validation messages
  VALIDATION: {
    VMS_SERVER_REQUIRED: 'VMS Server is required',
    PROFILE_NAME_REQUIRED: 'Profile Name is required',
    PROVIDER_NAME_REQUIRED: 'Provider Name is required',
    SERVER_SELECT_PLACEHOLDER: 'Select Server',
    SERVER_SELECT_PLACEHOLDER_ALT: 'Select server',
    NA_FALLBACK: 'N/A',
  },

  CONFIRMATION_MODALS: {
    UPDATE: {
      DESCRIPTION: 'Please confirm if you want to update the provider : ',
      TITLE: 'Update Provider',
      PLACEHOLDER: 'please type `confirm`',
      REGISTER_STRING: 'UpdateConfirm',
      CONFIRMATION_TEXT: 'confirm',
      CONFIRMATION_ERROR: "Please type 'confirm' to update.",
      MODAL_CONFIRMATION_TEXT: 'confirm',
      REQUIRED: 'This field is required.',
      CANCEL: 'Cancel',
    },

    // Partner ID change confirmation modal
    PARTNER_ID_CHANGE: {
      TITLE: 'Confirm Partner ID Change',
      SUBTITLE: 'This may affect VDI sync — please review carefully',
      CONFIRM_LABEL: 'Confirm change',
      INPUT_PLACEHOLDER: 'Type "confirm" to proceed',
      CONFIRM_KEYWORD: 'confirm',
      BODY_PREFIX: 'Changing Partner ID from',
      BODY_SUFFIX: 'can cause VDI sync.',
      VALIDATION_MSG_PREFIX: 'Please type',
      VALIDATION_MSG_SUFFIX: 'to proceed.',
      HINT_MSG_PREFIX: 'Enter',
      HINT_MSG_SUFFIX: 'to enable the update button.',
      UPDATE_BUTTON: 'Update Provider',
      CANCEL: 'Cancel',
    },
    ACTIVATE_MODAL: {
    TITLE: 'Reactivate Provider',
    SUBTITLE: 'Reactivate this provider to restore their access.',
    BODY_PREFIX: 'Are you sure you want to reactivate provider',
    CONFIRM_WORD: 'activate',
    PLACEHOLDER: 'Type "activate" to confirm',
    INPUT_LABEL: 'Confirmation',
    HINT: 'Please type the word above to confirm reactivation.',
    CONFIRM_LABEL: 'Reactivate Provider',
    TOOLTIP_FOR_NON_ADMINS: 'Only admins can reactivate providers.',
  },
  },
};

export const PROVIDER_VIEW_PROPS = {
  // Page header
  FALLBACK_TITLE: 'Provider Details',

  // Section cards
  SECTIONS: {
    DETAILS_TITLE: 'Provider Details',
    DETAILS_SUBTITLE: 'Identity & configuration information',
    CONFIG_TITLE: 'Configuration Settings',
    CONFIG_SUBTITLE: 'VDI integration endpoints & service configuration',
  },

  // StatCell labels
  FIELDS: {
    NAME: 'Name',
    PROVIDER_ID: 'Provider ID',
    PARTNER_ID: 'Partner ID',
    SERVER: 'Server',
    PROFILE: 'Profile',
    VDI_VERSION: 'VDI Version',
    VDI_SYNC: 'VDI Sync',
    CREATED_ON: 'Created On',
    LAST_UPDATED: 'Last Updated',
  },

  // ServiceCard labels
  SERVICES: {
    MMS: 'MMS',
    VMS: 'VMS',
    CLIENTS: 'Clients',
    ALERTS: 'Alerts',
    SMART_COOLERS: 'Smart Coolers',
  },

  // FeatureFlagCard
  FEATURES: {
    FORK_TRANSACTION_LABEL: 'Fork Transaction',
    FORK_TRANSACTION_DESC:
      'Enables forking of transaction processes across integrated services',
    RECONCILIATION_LABEL: 'Reconciliation',
    RECONCILIATION_DESC:
      'Enables automated reconciliation processing for financial transactions',
  },

  // Empty state
  EMPTY_STATE: {
    TITLE: 'No configuration available',
    SUBTITLE: 'This provider has no VDI settings configured yet',
  },

  // Action buttons
  ACTIONS: {
    EDIT: 'Edit',
    DELETE: 'Delete',
  },

  // Delete confirmation modal
  DELETE_MODAL: {
    TITLE: 'Remove Provider',
    SUBTITLE: 'This action is permanent and cannot be undone.',
    BODY_PREFIX: 'You are about to permanently delete',
    BODY_SUFFIX: '. All associated configuration data will be lost.',
    INPUT_PLACEHOLDER: 'Type "delete" to confirm',
    INPUT_LABEL: 'Confirm deletion',
    HINT_SUFFIX: 'to enable the confirmation button.',
    CONFIRM_LABEL: 'Delete Provider',
  },

  // List page search placeholders
  LIST: {
    SEARCH_BY_NAME: 'Search by Provider Name',
    SEARCH_BY_PARTNER_ID: 'Search by Partner ID',
    CREATE_BUTTON: 'Create Provider',
  },

  // Filters
  FILTERS: {
    STATUS_ALL: 'All',
    STATUS_ACTIVE: 'Active',
    STATUS_INACTIVE: 'Inactive',
  },
};

export const VDI_VERSION = {
  v1: '1',
  v2: '2',
};

export const SERVER_OPTIONS = [
  { id: 'GO', value: 'GO', label: 'GO', name: 'GO' },
  { id: 'SEED', value: 'SEED', label: 'SEED', name: 'SEED' },
  { id: 'SANDSTAR', value: 'SANDSTAR', label: 'SANDSTAR', name: 'SANDSTAR' },
  { id: 'VENDSYS', value: 'VENDSYS', label: 'VENDSYS', name: 'VENDSYS' },
];

export enum EAuthTypes {
  GOMINI = 'gomini',
  VDI = 'vdi',
  AUTH_MANAGEMENT = 'auth',
  SANDSTAR = 'sandstar',
  SEED = 'seed',
  SEN = 'sen',
  GO = 'go',
  KOOICK = 'kooick',
  KOOICK_JWT = 'kooick_jwt',
  SEED_KOOICK = 'seed_kooick',
  KOOICK_SEED = 'kooick_seed',
  NONE = 'none',
}

/**
 * Maps raw AUTH_TYPE server values (uppercase) to display labels.
 * Keys match what the server sends, uppercased.
 * Falls back to the raw value if not found.
 */
export enum EAuthTypeMapper {
  SANDSTAR = 'SANDSTAR',
  SEED = 'SEED',
  SEED_KOOICK = 'SEED',
  KOOICK_SEED = 'KOOICK',
  KOOICK = 'KOOICK',
  KOOICK_JWT = 'KOOICK JWT',
  GO = 'GO',
  SEN = 'SEN',
  GOMINI = 'GOMINI',
  VDI = 'VDI',
  AUTH = 'AUTH',
  NONE = 'NONE',
}

export const AUTH_TYPE_OPTIONS = [
  { label: 'None', value: EAuthTypes.NONE },
  { label: 'Gomini', value: EAuthTypes.GOMINI },
  { label: 'VDI', value: EAuthTypes.VDI },
  { label: 'Auth Management', value: EAuthTypes.AUTH_MANAGEMENT },
  { label: 'Sandstar', value: EAuthTypes.SANDSTAR },
  { label: 'Seed', value: EAuthTypes.SEED },
  { label: 'Sen', value: EAuthTypes.SEN },
  { label: 'Go', value: EAuthTypes.GO },
  { label: 'Kooick', value: EAuthTypes.KOOICK },
  { label: 'Kooick JWT', value: EAuthTypes.KOOICK_JWT },
  { label: 'Seed Kooick', value: EAuthTypes.SEED_KOOICK },
  { label: 'Kooick Seed', value: EAuthTypes.KOOICK_SEED },
];

export const VERSION_OPTIONS = [
  { label: 'None', value: 'none' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
];

export const PROVIDER_COLUMNS = {
  NAME: 'Name',
  PARTNER_ID: 'Partner ID',
  SERVER: 'Server',
  PROFILE: 'Profile',
  PROVIDER_ID: 'Provider ID',
  VDI_VERSION: 'VDI Version',
  SYNC_VDI: 'Sync VDI',
  CREATED_ON: 'Created On',
  UPDATED_ON: 'Updated On',
  ACTION: 'Action',
  TOOLTIPS: {
    PROFILE: 'Provider Name',
  },
};

export const PROVIDER_CONFIG_PROPS = {
  JSON_PLACEHOLDER: 'Paste your JSON configuration here...',
  VDI_TYPES_TITLE: 'VDI Types',
  VDI_TYPES_SUBTITLE: 'Select one or more types',
  PRO_TIP_TITLE: 'Pro Tip',
  PRO_TIP_BODY:
    'You can edit values freely or paste a full JSON. Removing existing keys is not allowed — only values can be changed.',
  SECTIONS: {
    ALERTS_TITLE: 'ALERTS Configuration',
    CLIENTS_TITLE: 'CLIENTS Configuration',
    MMS_TITLE: 'MMS Configuration',
    SMART_COOLERS_TITLE: 'SMART COOLERS Configuration',
    VMS_TITLE: 'VMS Configuration',
  },
  FIELDS: {
    HOST_URL: 'Host URL',
    AUTH_TYPE: 'Auth Type',
    AUTH_TYPE_PLACEHOLDER: 'Select auth type',
    VERSION: 'Version',
    VERSION_PLACEHOLDER: 'Select version',
    GET_STATE: 'Get State',
    ENABLED: 'Enabled',
    DISABLED: 'Disabled',
    XML_VERSION: 'XML Version',
    PROVIDER_ID: 'Provider ID',
    APPLICATION_ID: 'Application ID',
    APPLICATION_VERSION: 'Application Version',
  },
};
